import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import BomName from './BomName';
import BomEditName from './BomEditName';
import BomListingAction from './BomListingAction';
import useReduxState from 'src/hooks/useReduxState';
import { CreateProject } from 'src/reusable/bom';
import BOM from "@system/config/bom";
import { useBOMProjectStore } from "../../../../hooks/bom_project";
import { useBOMStore } from "../../../../hooks/bom";
import System from "../../../../helper/system";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import Common from "../../Common";
import { useSearchParams } from "react-router-dom";
import $ from "jquery";
import Helper from 'src/support/Helper';
import liveAuth from 'src/helper/liveAuth';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';

const bomId = System.getParams().bomId;
const addFrom = System.getParams().addFrom;

const BomListingHeader = (props) => {
    const dropDownAssignBomRef = useRef();
    const [__check] = useAxiosIndicatorCheck();
    const [isEdit, setIsEdit] = useReduxState(false, 'setIsEdit');
    const [projectList, setProjectList] = useState({});
    const [find_project_input_listing, set_find_project_input_listing] = useState('');
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    const [{ bom_detail_by_bom_id, bom_detail_by_bom_id_type }, { get_bom_detail_by_bom_id }, { bom_assign_to_project }] = useBOMStore();
    const [searchParams] = useSearchParams();
    const [BOM__Component__Loader] = useReduxState(searchParams.get(Common.param_key) ? searchParams.get(Common.param_key) : Common.default_component.param_value, Common.redux_key);
    const [{ }, { fetch_project_list }] = useBOMProjectStore();
    const avUserInfo = liveAuth.getAvUserInfo()
    const [_check_p] = useCheckAuthPermissions();    
    useEffect(() => {
        async function fetchHere() {
            if (bomId !== undefined && bomId !== "") {
                await fetch_project_list();
            }
            preventProjectAssignDropDownToClose();
            setTimeout(() => {
                preventProjectAssignDropDownToClose();
            }, 400)
            setTimeout(() => {
                preventProjectAssignDropDownToClose();
            }, 1000)
            setTimeout(() => {
                preventProjectAssignDropDownToClose();
            }, 1800)
            setTimeout(() => {
                preventProjectAssignDropDownToClose();
            }, 2000)
            setTimeout(() => {
                preventProjectAssignDropDownToClose();
            }, 3000)
        }

        fetchHere()
    }, []);


    useEffect(() => {
        /**
         * Set Events and Evars as per basav comment (14664)
         * Author: Devanshi Patel
         */
        if (bom_detail_by_bom_id?.bomId) {
            if (localStorage.getItem('uploaded_file')) {
                if (window?.digitalData) {
                    localStorage.removeItem('uploaded_file')
                    if (!window?.digitalData?.transaction) {
                        window.digitalData.transaction = {}
                    }

                    window.digitalData.transaction.bomSource = "BOM upload file";
                    window.digitalData.transaction.bomId = bomId;
                    window.digitalData.transaction.bomName = bom_detail_by_bom_id?.bomName;
                }
            }
            else if (window?.digitalData && bom_detail_by_bom_id_type?.isExternalBom) {
                if (!window?.digitalData?.transaction) {
                    window.digitalData.transaction = {}
                }

                window.digitalData.transaction.bomSource = "Design Hub";
                window.digitalData.transaction.bomId = bomId;
                window.digitalData.transaction.bomName = bom_detail_by_bom_id?.bomName;
            } else if (window?.digitalData && addFrom) {
                if (!window?.digitalData?.transaction) {
                    window.digitalData.transaction = {}
                }
                if (addFrom == 'AddPart') {
                    window.digitalData.transaction.bomSource = 'BOM - Add a part';
                }
                else if (addFrom == 'FindPart') {
                    window.digitalData.transaction.bomSource = 'BOM - Find a part';
                }
                else
                {
                    window.digitalData.transaction.bomSource = addFrom ? addFrom : '';
                }
                window.digitalData.transaction.bomId = bomId;
                window.digitalData.transaction.bomName = bom_detail_by_bom_id?.bomName;
            }
        }
    }, [bom_detail_by_bom_id?.bomId, bom_detail_by_bom_id_type]);

    useEffect(() => {
        setProjectList(bom_project_list)
    }, [bom_project_list]);
    useEffect(() => {
        if (dropDownAssignBomRef.current !== undefined && dropDownAssignBomRef.current) {
            preventProjectAssignDropDownToClose();
        }
    }, [dropDownAssignBomRef]);
    const preventProjectAssignDropDownToClose = () => {
        $(document).on('click', '.dropdown-menu', function (e) {
            e.stopPropagation();
        });
        $(document).on('click', '.dropdown', function (e) {
            e.stopPropagation();
        });
    };
    const getDisplayStatus = (singleProject) => {
        if (singleProject.projectName.toLowerCase().includes(find_project_input_listing.toLowerCase()) === false) {
            return false
        }
        return true
    };
    const assignProject = async (singleProject) => {
        await bom_assign_to_project({
            bomId, projectId: singleProject.projectId
        });
        System.alert('Project Assigned');
        closeProjectDropdown();
        await get_bom_detail_by_bom_id({ bomId })
    };

    const closeProjectDropdown = () => {
        let dropdownElem = document.getElementsByClassName('selectbox');
        if (dropdownElem !== undefined && dropdownElem.length > 0) {
            if (dropdownElem[0].classList.contains('open')) {
                dropdownElem[0].classList.remove('open');
            }
        }
    }

    const searchProject = (array, searchText) => {
        let count = 0;
        Object.entries(array).forEach(x => {
            if (x.length > 0 &&
                x[1].projectName !== undefined &&
                x[1].projectName !== null &&
                x[1].projectName.trim() !== '' &&
                x[1].projectName.toLowerCase().includes(searchText.toLowerCase().trim())) {
                ++count;
            }
        });
        return count;
    }
    return (
        <>
            <div className="bom-header">
                <div className="container">
                    <div className="row bs5">
                        <div className="col-sm-6 d-flex flex-wrap align-items-center">
                            <div className="d-flex align-items-center my-2 flex-column flex-lg-row">
                                <a className="me-3 mt-1 align-self-start"
                                    onClick={() => {
                                        if (System.getParams().redirect_back_url !== undefined && System.getParams().redirect_back_url) {
                                            window.location.href = System.getParams().redirect_back_url;
                                        } else {
                                            if (BOM__Component__Loader === 'BomProductListing') {
                                                window.location.href = BOM.getBomRouteURL();
                                            } else {
                                                window.location.href = BOM.getBomRouteURL()
                                            }
                                        }
                                    }}><i className="fa fa-angle-double-left" aria-hidden="true"></i> Return to Saved
                                    BOMs</a>

                                {isEdit === true ? <BomEditName /> : <BomName />}

                            </div>
                        </div>

                        {(!Helper.validateDomain(avUserInfo?.email) && (!bom_detail_by_bom_id_type?.isExternalBom || (bom_detail_by_bom_id_type?.isExternalBom && !_check_p('DOWNLOAD_BOM').status))) && <BomListingAction />}

                    </div>
                    <div className="pcn-line-divider" />
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="bs5 row" onClick={() => {
                                preventProjectAssignDropDownToClose();
                            }}>
                                <div className="col-auto" onClick={() => {
                                    preventProjectAssignDropDownToClose();
                                }}>
                                    {__check(['BOM_ASSIGN_TO_PROJECT_API_CALL'], { inline: true }).render}
                                    <div ref={dropDownAssignBomRef} className="dropdown selectbox w220" style={{
                                        display: !__check(['BOM_ASSIGN_TO_PROJECT_API_CALL']).status ? 'block' : 'none'
                                    }} onClick={() => {
                                        preventProjectAssignDropDownToClose();
                                    }}>
                                        <button onClick={() => {
                                            preventProjectAssignDropDownToClose();
                                        }} className="bs5 form-control form-control-sm dropdown-field-btn d-block"
                                            type="button" id="dropdownMenu1-1"
                                            data-toggle="dropdown">
                                            {projectList[bom_detail_by_bom_id?.projectId] !== undefined &&
                                                <>
                                                    {projectList[bom_detail_by_bom_id.projectId].projectName}
                                                </>
                                            }
                                            {projectList[bom_detail_by_bom_id?.projectId] === undefined &&
                                                <>
                                                    Assign to Existing Project
                                                </>
                                            }
                                        </button>

                                        <div className="dropdown-menu dropdown-field-box" id="dropdownMenu1-1">
                                            <div className="input-group mb-2">
                                                <input type="text" className="form-control form-control-sm"
                                                    placeholder="Search your projects"
                                                    onClick={() => {
                                                        preventProjectAssignDropDownToClose();
                                                    }}
                                                    onChange={(e) => set_find_project_input_listing(e.target.value)}
                                                    aria-label="Search your projects" id="txtSearch" />
                                                <div className="input-group-btn">
                                                    <button
                                                        className="bs5 btn btn-secondary btn-sm rounded-1 text-black-stone"
                                                        type="submit">
                                                        <span className="fa fa-search"></span>
                                                    </button>
                                                </div>
                                            </div>
                                            {projectList && Object.entries(projectList).length > 0 &&
                                                Object.entries(projectList).map((v, i) => (
                                                    <React.Fragment key={v[1].projectId}>
                                                        {getDisplayStatus(v[1]) &&
                                                            <a key={v[1].projectId}
                                                                className="dropdown-item text-black d-block px-0"
                                                                href={void (0)}
                                                                onClick={async () => {
                                                                    await assignProject(v[1])
                                                                }}
                                                            >{v[1].projectName}</a>
                                                        }
                                                    </React.Fragment>
                                                ))
                                            }
                                            {projectList && Object.entries(projectList).length > 0 &&
                                                find_project_input_listing !== undefined &&
                                                find_project_input_listing !== null &&
                                                find_project_input_listing.trim() != '' &&
                                                searchProject(projectList, find_project_input_listing) === 0 &&
                                                <>
                                                    <p className='error'>Error: No Project Found</p>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-2 col-sm-auto mt-sm-0">
                                    <CreateProject
                                        afterBOMCreation={async () => {
                                            await fetch_project_list()
                                            await fetch_bom_project_detail_with_bom();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default BomListingHeader;